// src/services/empresaService.js
import axios from "axios";

// Quita cualquier "/" al final para evitar dobles slashes al concatenar
const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
const API_URL = `${API_BASE}/api/empresas`;

/** Obtener todas las empresas */
export const obtenerEmpresas = () => axios.get(API_URL);

/**
 * Obtener una empresa por ID.
 * - Si tu backend expone GET /api/empresas/{id}, usamos esa ruta.
 * - Si no existe, como fallback probamos /api/empresas?id=.
 * Ajusta según tu API si la PK es EMPRESA y no Id.
 */
export const crearEmpresa = (empresa) => axios.post(API_URL, empresa);
export const actualizarEmpresa = (id, empresa) => axios.put(`${API_URL}/${id}`, empresa);

export const obtenerEmpresa = async (id) => {
  try {
    // Ruta REST típica: /api/empresas/{id}
    const { data } = await axios.get(`${API_URL}/${id}`);
    return data;
  } catch (e) {
    // Fallback por si tu API usa querystring: /api/empresas?id=#
    try {
      const { data } = await axios.get(`${API_URL}`, { params: { id } });
      // si devuelve arreglo, toma el primero
      if (Array.isArray(data) && data.length) return data[0];
      if (data?.data && Array.isArray(data.data) && data.data.length) return data.data[0];
      return data;
    } catch (e2) {
      throw e2;
    }
  }
};
